exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=checkbox][data-v-42154742]{-webkit-appearance:auto;-moz-appearance:auto;appearance:auto}", ""]);

// exports
